"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showToastState = void 0;
exports.default = Toast;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const recoil_1 = require("recoil");
const components_1 = require("@alcumus/components");
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const ErrorOutlineOutlined_1 = __importDefault(require("@mui/icons-material/ErrorOutlineOutlined"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
exports.showToastState = (0, recoil_1.atom)({
    key: 'showToastState',
    default: {
        showToast: false,
        severity: 'success',
        message: '',
        duration: 3000,
    },
});
const useStyles = (0, core_1.makeStyles)(() => ({
    alert: {
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h5,
        border: `1px solid ${components_1.StyleVariables.colors.border.default}`,
        borderRadius: 8,
    },
    icon: {
        alignSelf: 'center',
        '&.MuiAlert-icon': {
            color: (props) => props.severity === 'success'
                ? components_1.StyleVariables.colors.text.success
                : components_1.StyleVariables.colors.text.critical,
        },
    },
    success: {
        backgroundColor: components_1.StyleVariables.colors.alert.success,
        borderLeft: `8px solid ${components_1.StyleVariables.colors.text.success}`,
    },
    error: {
        borderLeft: `8px solid ${components_1.StyleVariables.colors.border.critical}`,
    },
    closeIcon: {
        borderRadius: 4,
    },
}));
function Toast() {
    const [items, setProps] = (0, recoil_1.useRecoilState)(exports.showToastState);
    const classes = useStyles({ severity: items.severity });
    const handleClose = () => {
        setProps({ ...items, showToast: false });
        if (items.onClose)
            items.onClose();
    };
    const getIcon = () => {
        if (items.severity === 'success')
            return react_1.default.createElement(CheckCircle_1.default, null);
        return react_1.default.createElement(ErrorOutlineOutlined_1.default, null);
    };
    return (react_1.default.createElement(core_1.Snackbar, { anchorOrigin: { vertical: 'top', horizontal: 'center' }, open: items.showToast, onClose: handleClose, autoHideDuration: items.duration },
        react_1.default.createElement(Alert_1.default, { className: classes.alert, classes: {
                icon: classes.icon,
                standardSuccess: classes.success,
                standardError: classes.error,
            }, action: react_1.default.createElement(core_1.IconButton, { disableRipple: true, className: classes.closeIcon, onClick: handleClose },
                react_1.default.createElement(Close_1.default, null),
                ' '), icon: getIcon(), severity: items.severity, onClose: handleClose }, items.message)));
}
